import { getLocaleInfo } from "../Config";
import moment from "moment";
import "moment/locale/ko";
import CryptoJS from "crypto-js";
import { servicePWcrypto } from "../scCommon/scCommonFunc";
import { GetServiceSetData, GetSubscriptionSetData } from "./ServiceDatasTS";
import { PayReason, PState, CPState, SubsFreeType } from "../Api/Types";
import SystemSet from "../datafiles/system_set.json";
import { GetStringByKey, GetStringByKeyValues } from "../Api/ApiTranslate";
import { ApiBase64 } from "../Api/ApiBase64";
import { getDiffDay } from "./LinkidCalc";
import { IPartyData, IPartyList } from "./CommonType";
import { CheckFWord } from "../Api/ApiChat";

// import { storePromise } from "../stores";
// import { store } from "../stores/webIndex";

// 화폐 단위
export const GetMoneyValue = (value: number) => {
  const commaReg = /\B(?=(\d{3})+(?!\d))/g;

  switch (getLocaleInfo()) {
    case "kokr":
      if (value && value < 0) {
        return "원";
      }
      return value?.toString()?.replace(commaReg, ",") + "원";

    case "koen":
      if (value && value < 0) {
        return "₩";
      }
      return "₩" + value?.toString()?.replace(commaReg, ",");

    default:
      return `${value}`;
  }
};

// 계좌 코드에 맞는 은행이름을 리턴한다. (쇼트 네임)
export const GetBankNameByBankCode = (bankcode: string) => {
  let bankName = "";
  switch (bankcode) {
    case "004":
      bankName = "KB국민";
      break;
    case "023":
      bankName = "SC제일";
      break;
    case "039":
      bankName = "경남";
      break;
    case "034":
      bankName = "광주";
      break;
    case "003":
      bankName = "IBK기업";
      break;
    case "011":
      bankName = "NH농협";
      break;
    case "031":
      bankName = "대구";
      break;
    case "032":
      bankName = "부산";
      break;
    case "002":
      bankName = "KDB산업";
      break;
    case "045":
      bankName = "새마을";
      break;
    case "007":
      bankName = "Sh수협";
      break;
    case "088":
      bankName = "신한";
      break;
    case "048":
      bankName = "신협";
      break;
    case "005":
      bankName = "외환은행";
      break;
    case "020":
      bankName = "우리";
      break;
    case "071":
      bankName = "우체국";
      break;
    case "037":
      bankName = "전북";
      break;
    case "090":
      bankName = "카카오뱅크";
      break;
    case "089":
      bankName = "케이뱅크";
      break;
    case "081":
      bankName = "하나";
      break;
    case "027":
      bankName = "시티";
      break;
    case "092":
      bankName = "토스";
      break;
    case "035":
      bankName = "제주";
      break;
    default:
      bankName = "";
      break;
  }

  return bankName;
};

// 계좌 코드에 맞는 풀 은행이름을 리턴한다. (풀 네임)
export const GetBankFullNameByBankCode = (bankcode: string) => {
  let bankName = "";
  switch (bankcode) {
    case "004":
      bankName = "KB국민은행";
      break;
    case "023":
      bankName = "SC제일은행";
      break;
    case "039":
      bankName = "경남은행";
      break;
    case "034":
      bankName = "광주은행";
      break;
    case "003":
      bankName = "IBK기업은행";
      break;
    case "011":
      bankName = "NH농협은행";
      break;
    case "031":
      bankName = "대구은행";
      break;
    case "032":
      bankName = "부산은행";
      break;
    case "002":
      bankName = "KDB산업은행";
      break;
    case "045":
      bankName = "새마을금고";
      break;
    case "007":
      bankName = "Sh수협은행";
      break;
    case "088":
      bankName = "신한은행";
      break;
    case "048":
      bankName = "신협";
      break;
    case "005":
      bankName = "외환은행";
      break;
    case "020":
      bankName = "우리은행";
      break;
    case "071":
      bankName = "우체국";
      break;
    case "037":
      bankName = "전북은행";
      break;
    case "090":
      bankName = "카카오뱅크";
      break;
    case "089":
      bankName = "케이뱅크";
      break;
    case "081":
      bankName = "하나은행";
      break;
    case "027":
      bankName = "시티은행";
      break;
    case "092":
      bankName = "토스뱅크";
      break;
    case "035":
      bankName = "제주은행";
      break;
    default:
      bankName = "";
      break;
  }

  return bankName;
};

export const GetServiceSetServiceNameByNumber = (servID: number) => {
  let serviceName = "";
  switch (servID) {
    case 1:
      serviceName = "Netflix";
      break;
    case 3:
      serviceName = "Wavve";
      break;
    case 2:
      serviceName = "Watcha";
      break;
    case 4:
      serviceName = "Tving";
      break;
    case 5:
      serviceName = "Disney";
      break;
    case 6:
      serviceName = "Spotify";
      break;
    case 7:
      serviceName = "Tidal";
      break;
    case 8:
      serviceName = "Office365";
      break;
    case 9:
      serviceName = "Adobe";
      break;
    default:
      break;
  }
  return serviceName;
};

// 링키드 머니 가져오기
export const GetCurrentLinkidMoney = (
  user: { userData: { money: number } },
  isJustValue: boolean
) => {
  if (user?.userData?.money) {
    if (isJustValue) {
      return user.userData.money;
    } else {
      return GetMoneyValue(user.userData.money);
    }
  }

  if (isJustValue) {
    return 0;
  } else {
    return GetMoneyValue(0);
  }
};

// 숫자 키패드 섞기
export const GetRandomKeypadNumber = () => {
  let array = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  for (let i = 0; i < array.length; i++) {
    let j = Math.floor(Math.random() * (i + 1));
    // [array[i], array[j]] = [array[j], array[i]];
    const x = array[i];
    array[i] = array[j];
    array[j] = x;
  }
  return array;
};

// 로그인을 했는지 여부
export const getNowLogined = (user?: { loginSuccess: { result: number } }) => {
  let logined = false;
  if (user && user.loginSuccess && user.loginSuccess.result === 0) {
    logined = true;
  }
  return logined;
};

// 암호화
export const encryptPW = (pw: string, uid: number) => {
  const pwJson = JSON.stringify(pw);
  var key = CryptoJS.enc.Utf8.parse(servicePWcrypto.Key(uid));
  var iv = CryptoJS.enc.Utf8.parse(servicePWcrypto.IV);
  var aesEncryptor = CryptoJS.algo.AES.createEncryptor(key, { iv: iv });

  var ddd = aesEncryptor.process(pwJson);

  var final = aesEncryptor.finalize();

  return ddd.toString(CryptoJS.enc.Hex) + final.toString(CryptoJS.enc.Hex);
};

// 복호화.
export const decryptPW = (pw: string, uid: number) => {
  try {
    var key = CryptoJS.enc.Utf8.parse(servicePWcrypto.Key(uid));
    var iv = CryptoJS.enc.Utf8.parse(servicePWcrypto.IV);
    var aesDecryptor = CryptoJS.algo.AES.createDecryptor(key, { iv: iv });

    var ddd = aesDecryptor.process(CryptoJS.enc.Hex.parse(pw));
    var final = aesDecryptor.finalize();

    const decValue =
      ddd.toString(CryptoJS.enc.Utf8) + final.toString(CryptoJS.enc.Utf8);

    if (IsJsonString(decValue)) {
      return JSON.parse(decValue);
    } else {
      return decValue;
    }
  } catch (error) {
    return false;
  }
};

export function IsJsonString(str: string) {
  try {
    var json = JSON.parse(str);
    return typeof json === "object";
  } catch (e) {
    return false;
  }
}

// 약 n 개월 구하기
export const getAboutMonth = (remainday: number) => {
  let month = Math.floor(remainday / 30);
  let day = remainday - month * 30;

  //남은 달 계산. 남은 달의 남은일수가 16이상이면 + 1
  if (day > 15) {
    return month + 1;
  } else {
    return month;
  }
};

export const getDayOfWeekTextKor = (dayIndex: number) => {
  let dowText = "";
  switch (dayIndex) {
    case 0:
      dowText = "일";
      break;
    case 1:
      dowText = "월";
      break;
    case 2:
      dowText = "화";
      break;
    case 3:
      dowText = "수";
      break;
    case 4:
      dowText = "목";
      break;
    case 5:
      dowText = "금";
      break;
    case 6:
      dowText = "토";
      break;
  }

  return dowText;
};

// 파티 생성, 가입, 요청 시도 시 내 파티 리스트와 확인해서 가능한 상태인지를 리턴한다.
export const getServiceTakeableData = (
  myAllPartyList: IPartyList,
  servID: number
) => {
  // noUsing, using, requested, endSoon

  let data = {
    status: "noUsing",
    endDate: "",
    requestedSubsID: 0,
    pid: 0,
  };

  if (!myAllPartyList) return data;

  const pList = myAllPartyList?.party;
  const reqPList = myAllPartyList?.partyreq;
  const uplusList = myAllPartyList?.uplus;
  const ServiceData = GetServiceSetData(servID);

  // 1. 요청 리스트에서 찾는다.
  if (reqPList) {
    for (let i = 0; i < reqPList?.length; i++) {
      const SubsData = GetSubscriptionSetData(reqPList[i].servsubsid);

      // 같은 서비스를 찾고
      if (SubsData?.SVC_ID && ServiceData?.SVC_ID === SubsData.SVC_ID) {
        data.status = "requested";
        data.requestedSubsID = SubsData.SUBS_ID;
        return data;
      }
    }
  }

  // 2. 유플러스  리스트에서 찾는다.
  if (uplusList) {
    for (let i = 0; i < uplusList?.length; i++) {
      const SubsData = GetSubscriptionSetData(900000);

      // 같은 서비스를 찾고
      if (SubsData?.SVC_ID && ServiceData?.SVC_ID === SubsData.SVC_ID) {
        const status = uplusList[i].status;
        // 1.  매칭중
        // 2. 결합중
        // 3. 파티중
        // 4. 종료

        if (status === 4) {
          continue;
        } else {
          data.status = "using";
          data.endDate = "9999-12-31";
        }

        return data;
      }
    }
  }

  // 3. 파티 리스트에서 찾는다.
  if (pList) {
    for (let i = 0; i < pList?.length; i++) {
      const SubsData = GetSubscriptionSetData(pList[i].servsubsid);

      // 같은 서비스를 찾고
      if (SubsData?.SVC_ID && ServiceData?.SVC_ID === SubsData?.SVC_ID) {
        const tState = pList[i].mystate ?? 8;

        // 탈퇴, 숨기기, 해산, 종료 상태 서비스는 가입.생성이 가능하다.
        if (
          tState === CPState.CPS_Exited || // 탈퇴 상태
          tState === PState.hidden || // 종료나 해산/탈퇴 후 감추기 된 상태
          tState === CPState.CPS_Broken || // 해산 상태
          tState === CPState.CPS_Ended || // 종료 상태.
          tState === CPState.CPS_ExitReady || // 탈퇴 대기
          tState === CPState.CPS_BreakReady // 해산 대기
        )
          continue;

        // 남은 날을 구하고,
        const remainDay = getDiffDay(
          moment(),
          moment(pList[i].enddate).add(-1, "d")
        );

        // 29일 이상 남았으면 생성이 불가하다.
        // (30일로 설정시 파티 가입시 날짜 검색 불가능한 케이스가 생겨 29일로 바꿈)
        if (remainDay >= 29) {
          data.status = "using";
          data.pid = pList[i].partyid;
        } else {
          const hasParentPid = pList.find(
            (val) => val.parentpid === pList[i].partyid
          ); // 연장한 파티

          if (hasParentPid) {
            data.status = "using";
            data.pid = pList[i].partyid;
          } else if (
            pList.find(
              (val) =>
                val.serv === pList[i].serv && val.mystate === CPState.CPS_Before
            ) !== undefined
          ) {
            // 예정 파티가 있다.
            data.status = "using";
            data.pid = pList[i].partyid;
          } else {
            data.status = "endSoon";
            data.endDate = pList[i].enddate;
            data.pid = pList[i].partyid;
          }
        }
        break;
      }
    }
  }

  return data;
};

// 링키드 정산 내역 적요
export const GetPayReasonStrByReasonID = (reason: number, isHost: boolean) => {
  let str = "";
  switch (reason) {
    case PayReason.Ch_PartyFee: // 1: 파티 요금 결제
      str = GetStringByKey(200025);
      break;
    case PayReason.Ch_PartyFee_PayDay: // 2: 파티 요금 결제 (정산일)
      str = GetStringByKey(200025);
      break;
    case PayReason.Ch_PenaltyFee: // 3: 파티 위약금 결제
      str = isHost ? GetStringByKey(200032) : GetStringByKey(200026);
      break;
    case PayReason.Ch_GuaranteeFee: // 4: 파티 보증금 거치
      str = GetStringByKey(200030);
      break;
    case PayReason.Re_EndRew: // 51: 파티 종료 적립 (정상)
      str = GetStringByKey(200027);
      break;
    case PayReason.Re_Compensation: // 52: 파티 보상금 적립
      str = GetStringByKey(200040);
      break;
    case PayReason.Re_PartyFee_PayDay: // 53: 파티 요금 적립 (정산일)
      str = GetStringByKey(200031);
      break;
    case PayReason.Re_EndRew_Exit: // 54: 파티 종료 적립 (중도 탈퇴)
      str = GetStringByKey(200029);
      break;
    case PayReason.Re_EndRew_Break: // 55: 파티 종료 적립 (중도 해산)
      str = GetStringByKey(200028);
      break;
    case PayReason.Re_PartyFee_PartyEnd: // 56: 파티 요금 적립 (종료 파티)
      str = GetStringByKey(200031);
      break;
    case PayReason.Re_PartyFee_PartyEnd_Sset: // 57: 파티 요금 적립 (종료 파티 선셋)
      str = GetStringByKey(200027);
      break;
    case PayReason.WithDraw: // 101: 인출
      str = GetStringByKey(200041);
      break;
    case PayReason.Admin_Cut_Money: // 102: 링키드 머니 차감 (어드민)
      str = GetStringByKey(200071);
      break;
    case PayReason.Admin_Charge_Money: // 103: 링키드 머니 충전 (어드민)
      str = GetStringByKey(200070);
      break;
    default:
      break;
  }
  return str;
};

export const GetPartyStateFromServer = (
  _mstate: number,
  _pstate: number,
  grade: number,
  isSlot: boolean
) => {
  // mstate
  // 0	정상
  // 1	탈퇴 신청중
  // 2	탈퇴 완료
  // 3	미결제

  // pstate
  // hidden	안보이기	-1
  // using	정상	0
  // broken	해산	1
  // ended	종료	2
  // breaking	해산대기	3

  // grade
  // 0	파티장
  // 1	파티원

  // 최종
  // 멤버로써
  // 0 정상, 1 탈퇴 신청 중, 2 탈퇴 완료 , 3 미결제
  // 파티 로써
  // -1 감추기 ,0 정상, 1 해산, 2 종료, 3 해산대기,

  if (isSlot) {
  } else {
    //  파티 장이면,
    if (grade === 0) {
    }
    // 파티 원 이면,
    else {
    }
  }
};

// 현재 유효한 파티 리스트
export const GetNowValidPartyLists = (partyList: IPartyData[]) => {
  let validPartyList = [];
  for (let i = 0; i < partyList?.length; i++) {
    const party = partyList[i];
    const state = party.mystate ?? 8;

    if (state === CPState.CPS_Using) {
      validPartyList.push(partyList[i]);
    }
  }

  return validPartyList;
};

// 현재 탈퇴/해산 대기 중인 파티 리스트
export const GetNowExitOrBreakReadyPartyLists = (partyList: IPartyData[]) => {
  let notValidPartyList = [];

  for (let i = 0; i < partyList?.length; i++) {
    const state = partyList[i].mystate ?? 8;

    if (state === CPState.CPS_ExitReady || state === CPState.CPS_BreakReady) {
      notValidPartyList.push(partyList[i]);
    }
  }

  return notValidPartyList;
};

export const ReplaceStrAt = (str: string, index: number, character: string) => {
  const Str = String(str);
  return (
    Str.substr(0, index) + character + Str.substr(index + character.length)
  );
};

// 시스템 세팅 데이터
export const GetSystemSetData = () => {
  return SystemSet[0];
};

export const CheckIsLimitWebPlatform = (servid: number, isMake: boolean) => {
  let isLimitedPlatform = false;

  const servData = GetServiceSetData(servid);

  if (servData) {
    if (isMake && servData.SVC_LMTPF !== null) {
      const limits = servData.SVC_LMTPF.split(",");
      for (let i = 0; i < limits.length; i++) {
        if (limits[i] === "web") {
          isLimitedPlatform = true;
          break;
        }
      }
    } else if (!isMake && servData?.SVC_LMTFIND) {
      const limits = servData?.SVC_LMTFIND.split(",");
      for (let i = 0; i < limits.length; i++) {
        if (limits[i] === "web") {
          isLimitedPlatform = true;
          break;
        }
      }
    }
  }
  return isLimitedPlatform;
};

// 공유이메일, 아이디 타입, 프로필닉네임 정보를 로드한다.
export const GetSplitMyPartyAccInfo = (accInfo: string) => {
  var parsed;

  try {
    parsed = JSON.parse(accInfo);
    let value = {
      id: parsed?.shareid,
      idType: parsed?.idtype,
      profileName: parsed?.profileName,
      ldrPday: parsed?.ldrPday,
      agList: parsed?.agList ?? [], //가입/생성시 동의한 리스트 (agreement_set.json 의 INDEX 값)
      srise: parsed?.srise ?? 0,
      old: parsed?.old ?? 0, // 연장파티가입 or 선라이즈 파티가입자는 1
    };
    return value;
  } catch (e) {
    if (e instanceof SyntaxError) {
      // 옛날 파싱 /T/
      const data = accInfo?.split("/T/") ?? [];

      let value = {
        id: data?.[0] ?? "",
        idType: data?.[1] ? data[1] : "",
        profileName: "",
        ldrPday: 0,
        agList: [],
        srise: 0,
        old: 0,
      };
      return value;
    }
  }
};

// 비밀번호 마스킹
export const GetMakeHideStringByLength = (str: string) => {
  let value = "";

  if (str) {
    for (let i = 0; i < str.length; i++) {
      value = value + "*";
    }
    return value;
  }
};

// 만나이 계산
export const GetKoreanAge = (birth: string) => {
  const userBirthYear = +birth?.split("-")[0];
  const userBirthMonth = +birth?.split("-")[1];
  const userBirthDay = +birth?.split("-")[2];

  const today = new Date();
  const userBirthDate = new Date(
    userBirthYear,
    userBirthMonth - 1,
    userBirthDay
  );

  let age = today.getFullYear() - userBirthDate.getFullYear();

  const monthDiff = today.getMonth() - userBirthDate.getMonth();
  const dateDiff = today.getDate() - userBirthDate.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dateDiff < 0)) {
    age--; // 생일이 지나지 않았을 경우 -1을 해줌
  }

  return age;
};

// 서비스 사용 가능한 나이인지 체크
export const CheckUseableByKoreanAge = (
  servId: number,
  user?: { loginSuccess?: { result: number; birthday: string } }
) => {
  let value = false;

  if (user?.loginSuccess?.result === 0 && user?.loginSuccess?.birthday !== "") {
    const kAge = GetKoreanAge(user.loginSuccess.birthday);
    const serviceData = GetServiceSetData(servId);
    if (serviceData && kAge >= serviceData.SVC_LMTAGE) {
      value = true;
    }
  } else {
    value = true;
  }

  return value;
};

// 파티 상태 스트링
export const getCurrentPartyStatusStr = (status: number) => {
  let str = "";
  switch (status) {
    case CPState.CPS_Before: // 1
      str = GetStringByKey(200047);
      break;
    case CPState.CPS_Requested: // 2
      str = GetStringByKey(200048);
      break;
    case CPState.CPS_ExitReady: // 3
      str = GetStringByKey(200050);
      break;
    case CPState.CPS_Exited: // 4
      str = GetStringByKey(200052);
      break;
    case CPState.CPS_BreakReady: // 5
      str = GetStringByKey(200049);
      break;
    case CPState.CPS_Broken: // 6
      str = GetStringByKey(200051);
      break;
    case CPState.CPS_Ended: // 7
      str = GetStringByKey(200053);
      break;
    case CPState.CPS_Using: // 8
      str = GetStringByKey(200046);
      break;

    default:
      break;
  }
  return str;
};

// 유닉스 시간 =>
export const GetTimeFromUnixTime = (time: number) => {
  var date = new Date(time * 1000);
  var year = date.getFullYear();
  var month = "0" + (date.getMonth() + 1);
  var day = "0" + date.getDate();
  var hour = "0" + date.getHours();
  var minute = "0" + date.getMinutes();

  return (
    year +
    "." +
    month.substr(-2) +
    "." +
    day.substr(-2) +
    " " +
    hour.substr(-2) +
    ":" +
    minute.substr(-2)
  );
};

// 유효한 이메일 형식인지 체크
export const checkIsEmailType = (idValue: string) => {
  const emailRule =
    // /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
    /([\w-\.]+)@((?:[\w]+\.)+)([a-zA-Z]{2,4})/i;
  if (emailRule.test(idValue)) {
    // 유효한 이메일 형식이면 true
    return true;
  } else {
    // 유효하지 않으면 false
    return false;
  }
};

export const encodeBase64 = (data: string) => {
  return ApiBase64.btoa(unescape(encodeURIComponent(data)));
};
export const decodeBase64 = (data: string) => {
  return decodeURIComponent(escape(ApiBase64.atob(data)));
};

// 정산일 변경 가능한지 체크
export const checkIsPaydayChangeable = (
  partyList: {
    mystate: number;
  }[]
) => {
  let usingBeforePartyList = [];

  for (let i = 0; i < partyList.length; i++) {
    const state = partyList[i].mystate ?? 8;

    if (state === CPState.CPS_Using || state === CPState.CPS_Before) {
      usingBeforePartyList.push(partyList[i]);
    }
  }

  // 파티 중인 파티 리스트 + 미래 파티 리스트 > 0 ? 정산일 변경 x: 정산일 변경 ㅇ
  if (usingBeforePartyList?.length > 0) {
    return false;
  } else {
    return true;
  }
};

// 링키드 포인트 히스토리 적요
export const getPointTitleString = (lpType: number) => {
  if (lpType === 201) {
    return 200068; // 링키드 포인트 사용
  } else if (lpType === 203) {
    return 200064; // 링키드 포인트 만료
  } else if (lpType === 204) {
    return 200072; // 링키드 포인트 차감
  } else if (lpType === 104) {
    return 200065; // 링키드 포인트 환불
  } else if (lpType === 202) {
    return 200067; // 링키드 머니로 전환
  } else if (lpType === 101 || lpType === 102 || lpType === 103) {
    return 200063; // 링키드 포인트 적립
  }
};

// 3자리 마다 찍기
export const getThousandComma = (value: number) => {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return value;
  }
};

// 포인트 스트링
export const getLPointShowValue = (value: number) => {
  let val = getThousandComma(value);
  return GetStringByKeyValues(40194, [{ target: "{lp_value}", value: val }]);
};

// 현재 월 구하기
export const getDateMonth = () => {
  const date = new Date();
  const month = date.getMonth() + 1;
  return month;
};

// byte에 따라 문자열 자르기
export const cutByteLength = (str: string, maxByte: number) => {
  let b, i, c;

  for (b = i = 0; (c = str.charCodeAt(i)); ) {
    b += c >> 7 ? 2 : 1;

    if (b > maxByte) break;

    i++;
  }

  return str.substring(0, i);
};

// 몇 byte인지 구하기
export const getByteLength = (str: string) => {
  return str
    .split("")
    .map((s) => s.charCodeAt(0))
    .reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0);
};

/** cutByte 만큼 문자열 자르고 줄임표 return 하기 */
export const getEllipsis = (str: string, cutByte: number) => {
  return str === ""
    ? "-"
    : str?.length > cutByte
    ? str?.substr(0, cutByte) + "..."
    : str ?? "-";
};

/** 맨 마지막 글자에 받침이 있는지 찾는 함수 */
export const isEndWithConsonant = (str: string) => {
  const korReg = /[ㄱ-ㅣ가-힣]/g;

  // 한글인 경우에만 체크
  if (korReg.test(str)) {
    const finalChrCode = str?.charCodeAt((str?.length ?? 0) - 1) ?? 0;
    // 0 = 받침 없음, 그 외 = 받침 있음
    const finalConsonantCode = (finalChrCode - 44032) % 28;
    return finalConsonantCode !== 0;
  } else {
    return true;
  }
};

/** start <= x < end 범위 list */
export const range = (start: number, end: number) => {
  const length = end - start;
  return Array.from({ length }, (_, i) => start + i);
};

/** 만 19세 ~ 만 29세 생년월일 리스트 */
export const getValidBirthList = (
  selectedYear: string,
  selectedMonth: string
) => {
  const nowYear = moment().year();
  const nowMonth = moment().month() + 1;
  const nowDate = moment().date();

  const isSelected = !(
    String(selectedYear)?.includes("생년월일") ||
    String(selectedMonth)?.includes("생년월일")
  );

  const lastDate = new Date(
    isSelected ? Number(selectedYear) : nowYear,
    isSelected ? Number(selectedMonth) : nowMonth,
    0
  ).getDate();

  const defaultYearList = [...range(nowYear - 30, nowYear - 18)];
  const defaultMonthList = [...range(1, 13)];
  const defaultDateList = [...range(1, lastDate + 1)];

  const updatedMonthList =
    Number(selectedYear) === nowYear - 19
      ? [...range(1, nowMonth + 1)] // 만 19세일 경우
      : [...range(nowMonth, 12 + 1)]; // 만 29세일 경우
  const updatedDateList =
    Number(selectedYear) === nowYear - 19
      ? [...range(1, nowDate + 1)] // 만 19세일 경우
      : [...range(nowDate + 1, lastDate + 1)]; // 만 29세일 경우

  return {
    year: defaultYearList,
    month:
      Number(selectedYear) === defaultYearList[0] ||
      Number(selectedYear) === defaultYearList[defaultYearList.length - 1]
        ? updatedMonthList
        : defaultMonthList,
    date:
      Number(selectedMonth) === updatedMonthList[0] ||
      Number(selectedMonth) === updatedMonthList[updatedMonthList.length - 1]
        ? updatedDateList
        : defaultDateList,
  };
};

// transfer mail 생성 시, 입력한 스트링 형식을 체크하고 결과를 리턴.
export const checkIsTransferEmailNameType = (str: string) => {
  // 1. 정해진 형식을 체크한다.
  //---- 4~12자 소문자와 숫자만
  //---- 영어로 시작해야함
  var regType = /^[a-z][a-z0-9]{3,11}$/;
  const regChk = regType.test(str);
  if (regChk === false) {
    return false;
  }

  //2. 금지어에 있으면 안됨
  const fworddata = CheckFWord(str);
  if (fworddata.hasFword) {
    return false;
  }

  return true;
};

/** string parsing to json */
export const parsingJson = (parsingStr: string) => {
  let parsed;

  try {
    parsed = JSON.parse(parsingStr);
  } catch (error) {
    if (error instanceof SyntaxError) {
      parsed = "{}";
    }
  }

  return parsed;
};

export const getKoreaNow = () => {
  const now = new Date(); // 현재 시간
  const utcNow = now.getTime() + now.getTimezoneOffset() * 60 * 1000; // 현재 시간을 utc로 변환한 밀리세컨드값
  const koreaTimeDiff = 9 * 60 * 60 * 1000; // 한국 시간은 UTC보다 9시간 빠름(9시간의 밀리세컨드 표현)
  const koreaNow = new Date(utcNow + koreaTimeDiff); // utc로 변환된 값을 한국 시간으로 변환시키기 위해 9시간(밀리세컨드)를 더함
  return koreaNow;
};

export const getNowMomentByServerTime = () => {
  // return getKoreaNow();

  return moment().format("YYYY-MM-DD");

  // const state = storePromise.getState();
  // const state = store.getState();

  // let state = null;

  // if (typeof document !== "undefined") {
  //   // I'm on the web!
  //   console.log("웹!!");
  //   // import { storePromise } from "../stores";
  //   // import { store } from "../stores/webIndex";
  //   // const store = require("../stores/webIndex");

  //   // const store = React.lazy(() => import("../stores/webIndex"));
  //   // state = store.getState();

  //   import("../stores/webIndex")
  //     .then(({ store }) => {
  //       // 경로안에있는함수();
  //       state = store.getState();

  //       console.log(store, state);

  //       const timeGap = state?.user?.loginSuccess?.timeGap ?? 0;
  //       console.log(timeGap, "timeGap ddd", state);

  //       const addValue = -timeGap;

  //       const modifiedNow = moment().add(addValue, "hour").format("YYYY-MM-DD");

  //       console.log("아러아ㅓㄹ아ㅓㄹ아ㅓㄹ아러알", modifiedNow);

  //       return modifiedNow;
  //     })
  //     .catch((err) => console.log(err));
  // } else if (
  //   typeof navigator !== "undefined" &&
  //   navigator.product === "ReactNative"
  // ) {
  //   // I'm in react-native
  //   console.log("APPPPPPP");

  //   // const storePromise = React.lazy(() => import("../stores"));
  //   import("../stores")
  //     .then(({ storePromise }) => {
  //       // 경로안에있는함수();
  //       state = storePromise.getState();

  //       console.log(storePromise, state);

  //       const timeGap = state?.user?.loginSuccess?.timeGap ?? 0;
  //       console.log(timeGap, "timeGap ddd", state);

  //       const addValue = -timeGap;

  //       const modifiedNow = moment().add(addValue, "hour").format("YYYY-MM-DD");

  //       console.log("아러아ㅓㄹ아ㅓㄹ아ㅓㄹ아러알", modifiedNow);

  //       return modifiedNow;
  //     })
  //     .catch((err) => console.log(err));

  //   // state = storePromise.getState();
  // }
};

export const getSubsFreeType = (subsid: number) => {
  const subsData = GetSubscriptionSetData(subsid ?? 0)!;

  const subsFee = subsData?.SUBS_FEE ?? 0;
  const guarMmgpx = subsData?.GUAR_MMGPX ?? 0;
  const guarMbrpx = subsData?.GUAR_MBRPX ?? 0;

  if (subsFee + guarMmgpx + guarMbrpx === 0) {
    return SubsFreeType.FREE_ALL;
  } else if (subsFee === 0) {
    return SubsFreeType.FREE_SUBSFEE;
  } else if (guarMmgpx + guarMbrpx === 0) {
    return SubsFreeType.FREE_DEPOSIT;
  } else {
    return SubsFreeType.NO_FREE;
  }
};
